// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"71397688","583":"effe571e","710":"18b0c8fb"}[chunkId] + ".chunk.js";
};